// extracted by mini-css-extract-plugin
export default {"qr_svg_wrapper":"TenantDetailQr_qr_svg_wrapper__-6PWS","qr_svg":"TenantDetailQr_qr_svg__PqVhh"};